export const NO_URL_NEEDED = "NO_URL_NEEDED"

export const makeAbsoluteUrl = (url: string, defaultUrl = null): string => {
  if (defaultUrl === NO_URL_NEEDED) {
    return ""
  }
  if (url?.startsWith("http")) {
    return url
  } else {
    return "http://" + url
  }
}
